import gql from "graphql-tag";

export const GENERATE_LOW_TAX_BROKER_MASKED_JSON = gql`
  mutation generateLowTaxBrokerMaskedJson($orderId: ID!) {
    generateLowTaxBrokerMaskedJson(orderId: $orderId) {
      feedback
    }
  }
`;
